import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ModalController, NavParams} from '@ionic/angular';
import {ApiService} from '../service/api.service';
import { HelperService } from '../service/helper.service';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EventComponent implements OnInit, OnDestroy {

  screen: any;
  content: '';
  isDesktop = false;

  constructor(
    public modalCtr: ModalController,
    private navParams: NavParams,
    private apiService: ApiService,
    private hpService: HelperService,
  ) {
    this.isDesktop = this.hpService.isDesktop;

    if (this.navParams.get('screen')) {
      this.screen = this.navParams.get('screen');
    }

    this.getContentEvent();
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
  }

  async closeModal() {
    await this.modalCtr.dismiss();
  }

  async switchScreen(screen) {
    await this.modalCtr.dismiss(screen);
  }

  getContentEvent() {
    this.apiService.getContentEvent().subscribe(
      res => {
        this.content = res;
      });
  }
}
